function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-unused-vars: ["error", { "args": "none" }] */
import React, { useState } from 'react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';

const DateRangePickerWrapper = ({
  startDateId,
  endDateId,
  id,
  onDatesChange,
  children,
  onChange,
  ...props
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  const handleDatesChange = ({
    startDate,
    endDate
  }) => {
    setStartDate(startDate);
    setEndDate(endDate);
    onChange({
      startDate: startDate ? startDate.toDate() : null,
      endDate: endDate ? endDate.toDate() : null
    });
  };

  delete props.inputRef;
  return /*#__PURE__*/React.createElement(DateRangePicker, _extends({
    startDate: startDate,
    endDate: endDate,
    startDateId: "startDate",
    endDateId: "endDate",
    onDatesChange: handleDatesChange,
    focusedInput: focusedInput,
    onFocusChange: focusedInput => setFocusedInput(focusedInput)
  }, props));
};

export default DateRangePickerWrapper;